import Vue from "vue";

/**
 * Class Wine Service
 */
export default class WineService extends Vue {
  private customActions = {
    wineUpgradePlan: { method: 'PUT', url: 'integration/async/wine/upgrade-plan' }
  };

  private resource: any = this.$resource('integration/', {}, this.customActions);

  public async wineUpgradePlan(params: any) {
    return await this.resource.wineUpgradePlan({}, params);
  }
}